// ErrorState.tsx — gentle, non-alarming error/empty/offline state with a retry.
import { Display, Body, Btn } from './ui';
import { Icon, type IconName } from './icons';

export function ErrorState({
  title = 'We could not load this just now',
  message = 'It may be a connection hiccup. Nothing you did is wrong — try again when you’re ready.',
  onRetry,
  retryLabel = 'Try again',
  icon = 'leaf',
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  icon?: IconName;
}) {
  return (
    <div
      role="alert"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        padding: '24px 32px',
        textAlign: 'center',
      }}
    >
      <span
        style={{
          width: 56,
          height: 56,
          borderRadius: 999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--amber-deep)',
          background: 'rgba(200,134,26,0.1)',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.5)',
        }}
      >
        <Icon name={icon} size={24} />
      </span>
      <Display parts={{ pre: '', em: title }} size={21} lh={1.2} />
      <Body dim size={14} style={{ maxWidth: 300 }}>
        {message}
      </Body>
      {onRetry && (
        <div style={{ marginTop: 6 }}>
          <Btn variant="soft" onClick={onRetry} leading={<Icon name="more" size={16} />}>
            {retryLabel}
          </Btn>
        </div>
      )}
    </div>
  );
}
